export default function Home() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-white mb-4">DFX Review</h1>
        <p className="text-gray-400 max-w-md">
          This is the review portal for DFX Pipeline episodes. Access your
          review using the magic link sent to your email.
        </p>
      </div>
    </div>
  );
}
